import { apiGet, apiPost, apiDelete } from './client';

export interface MailFolder {
  id: string;
  displayName: string;
  parentFolderId?: string | null;
  childFolderCount?: number;
  totalItemCount?: number;
  unreadItemCount?: number;
}

export interface GraphWebhookSubscription {
  id: string;
  resource: string;
  expiryAt: string;
  active: boolean;
  /** True when active was confirmed with Graph; false means DB-only status. */
  verified: boolean;
}

export interface MailboxResponse {
  folders: MailFolder[];
  subscriptions: GraphWebhookSubscription[];
}

export async function getMailFolders(): Promise<MailboxResponse> {
  return apiGet<MailboxResponse>('/api/mailbox');
}

export async function subscribe(): Promise<void> {
  await apiGet('/api/mailbox/subscribe');
}

export async function unsubscribe(): Promise<{ deleted: number }> {
  return apiDelete<{ deleted: number }>('/api/mailbox/unsubscribe');
}

export async function recategorise(conversationId: string): Promise<{
  conversationId: string;
  skipped: boolean;
  retryAfterSeconds?: number;
}> {
  return apiPost('/api/categorization/recategorise', { conversationId });
}

export interface ScanInboxResult {
  queued: number;
  daysBack: number;
  skipRecentDays: number;
}

export async function scanInbox(params?: { daysBack?: number; skipRecentDays?: number }): Promise<ScanInboxResult> {
  return apiPost<ScanInboxResult>('/api/mailbox/scan-inbox', params);
}
